import * as React from 'react';

import { createIcon } from '../Icon';
export const HourglassIcon = createIcon(
  <path d="M19.88 20.8H18.75V17.06C18.75 15.96 18.19 14.91 17.23 14.31L13.91 12L17.18 9.69C18.13 9.09 18.69 8.04 18.69 6.94V3.2H19.82C20.44 3.2 20.94 2.71 20.94 2.1C20.94 1.5 20.44 1 19.82 1H17.62H17.57H6.38H6.32H4.12C3.51 1 3 1.5 3 2.1C3 2.71 3.51 3.2 4.12 3.2H5.25V6.94C5.25 8.04 5.81 9.09 6.77 9.69L10.03 12L6.77 14.31C5.81 14.91 5.25 15.96 5.25 17.06V20.8H4.12C3.51 20.8 3 21.3 3 21.9C3 22.5 3.51 23 4.12 23H6.32H6.38H17.62H17.68H19.88C20.49 23 21 22.5 21 21.9C21 21.3 20.49 20.8 19.88 20.8ZM8.01 7.88C7.67 7.66 7.5 7.33 7.5 6.94V3.2H16.5V6.94C16.5 7.33 16.33 7.66 15.99 7.88C15.99 7.88 15.94 7.88 15.94 7.93L12 10.68L8.01 7.88C8.06 7.88 8.06 7.88 8.01 7.88ZM7.5 17.06C7.5 16.68 7.67 16.34 8.01 16.12C8.01 16.12 8.06 16.12 8.06 16.07L12 13.32L15.94 16.07C15.94 16.07 15.99 16.07 15.99 16.12C16.33 16.34 16.5 16.68 16.5 17.06V20.8H7.5V17.06Z" />,
  'HourglassIcon',
  {
    fill: true,
    stroke: false,
  }
);
